import React, { Component } from 'react';
import language from '../../assets/languages/language';
import { Modal, ModalBody, ModalHeader, Button } from 'reactstrap';
import { renderHTMLContent } from '../../common/function';

class CBTMockExamsInsructions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      instruct: false,
      content: '',
    };
  }

  pdfAlertModel = (e) => {
    e.preventDefault();
    this.props.pdfAlertModel(e);
  };
  start = () => {
    const { instruct } = this.state;
    if (instruct) {
      this.setState({
        content: '',
      });
      this.setState({
        instruct: false,
      });
      this.props.getQuestions();
    } else {
      this.setState({
        content:
          'You have not accepted the terms. You must accept the terms before you can take the test.',
      });
    }
  };
  changeValue = (e) => {
    const { target } = e;
    const { checked } = target;
    if (checked) {
      this.setState({
        instruct: true,
      });
    } else {
      this.setState({
        instruct: false,
      });
    }
  };
  close = () => {
    this.setState({
      instruct: false,
    });
    this.props.handleClose();
  };
  render() {
    let selectedMenu = localStorage.getItem('selectedmenu');
    const { showInstructionModal } = this.props;
    const { instruct, content } = this.state;
    return (
      <Modal
        isOpen={showInstructionModal}
        toggle={() => this.close()}
        className={
          'modal-primary custom_modalpro info-modal-designing' +
          this.props.className
        }
      >
        <ModalHeader toggle={() => this.close()} className='custom-title'>
          <i className='fa fa-info-circle' aria-hidden='true' />{' '}
          {language.LC().INSTRUCTIONS}
        </ModalHeader>
        <ModalBody className='text-center'>
          <div className='modal-info-view-for-plan '>
            {selectedMenu === 'cfa' ? (
             renderHTMLContent(language.LC().CBT_MOCK_INSTRUCTIONS, "div")
            ) : (
             renderHTMLContent(language.LC().CBT_MOCK_INSTRUCTIONS_FRM, "div")
            )}
            <div className='plan_wrapper remove-plan mt-1'>
              <label className='check_container'>
                <input
                  type='checkbox'
                  value='on'
                  checked={instruct ? true : false}
                  onChange={(e) => this.changeValue(e)}
                />
                <span className='checkmark' />
                {language.LC().I_ACCEPT_THE_TERMS}
              </label>
              {content ? <div className='error-sms'>{content}</div> : ''}
            </div>
            <div className='btn-plan-view view-plan-wrap'>
              <Button
                className='btn btn-primary margin_right_20'
                onClick={() => this.close()}
              >
                {' '}
                {language.LC().GO_TO_ANSWER}{' '}
              </Button>
              <Button className='btn btn-primary' onClick={() => this.start()}>
                {' '}
                {language.LC().START}{' '}
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

export default CBTMockExamsInsructions;



// WEBPACK FOOTER //
// ./src/views/Common/CBTInstructions.js